import { useEvaluateCommonApi } from '~/composables/hr-evaluation/evaluate/common/useEvaluateCommonApi';
import { mapActivityListForCards } from '~/composables/domain/activity/mapActivityListForCards';

/**
 * KPI/KR 활동 탭 공용: 업무(Plan) 1건의 활동 목록을 카드 형식으로 조회한다.
 * /hcm/obj/idpMng/selectActivity_json.do (findYear, planId → activityDatas)
 */
export async function fetchPlanActivitiesForTab(plan: Record<string, unknown> | null | undefined, findYear: string) {
  const planId = String((plan as any)?.planId || '');
  if (!planId || !findYear) return [];

  const { fetchSelectActivityDatas } = useEvaluateCommonApi();

  try {
    const params = new URLSearchParams();
    params.append('findYear', findYear);
    params.append('planId', planId);
    const response = await fetchSelectActivityDatas(params);
    const rawList = Array.isArray(response?.activityDatas)
      ? response.activityDatas
      : Array.isArray(response?.activityList)
        ? response.activityList
        : [];
    return mapActivityListForCards(rawList);
  } catch (e) {
    console.error('[fetchPlanActivitiesForTab] selectActivity_json.do failed', e);
    return [];
  }
}
